var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('Head',{staticClass:"head"}),_c('div',{staticClass:"content"},[_c('keep-alive',{attrs:{"include":_vm.cashRouters}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }